// extracted by mini-css-extract-plugin
module.exports = {"blink":"CardPromo_blink__2z2z5","blinker":"CardPromo_blinker__3HHDG","table":"CardPromo_table__LsYEY"};